export enum PictureUploadKind {
  insuranceCardBackImage = 'insurance_back',
  insuranceCardFrontImage = 'insurance_front'
}
